<template>
  <div class="productCard">
      <div class="header">
        <div class="photo">
          <img :src="firstPic"/>
        </div>
          <div class="desc">
            <div class="title">{{title}}</div>
            <div class="price">
              <div class="symbol">¥</div>
              <div class="num">{{price}}</div>
            </div>
          </div>
      </div>
      <z-divider />
      <div class="sellerName">
        <div class="key">卖家昵称</div>
        <div class="value">{{sellerName}}</div>
      </div>
      <div class="orderCode">
        <div class="key">订单编号</div>
        <div class="value">{{orderId}}</div>
      </div>
      <div class="payTime" v-if="Number(payTime)">
        <div class="key">支付时间</div>
        <div class="value">{{payTime | formatTime}}</div>
      </div>
    </div>
</template>
<script>

import { Divider } from '@zz-common/zz-ui';
import { queryParams, getCookie } from '@lib/utils'
import { queryDisclosureOrderInfo } from '@api/resourceApi'
import native from '@zz-common/native-adapter';

const query = queryParams()

export default {
  name: 'prodcutCard',
  data() {
    return {
      uid: getCookie('uid'),
      orderId: query.orderId || this.$route.query.orderId || '',
      firstPic: '',
      title: '',
      infoId: '',
      sellerName: '',
      payTime: '',
      price: ''
    }
  },
  components: {
    'z-divider': Divider
  },
  computed: {
  },
  filters: {
    formatTime(timeStamp) {
      return timeStamp ? new Date(Number(timeStamp)).format('YYYY-MM-DD HH:mm:ss') : ''
    }
  },
  methods: {
  },
  created() {
    const params = {
      uid: this.uid,
      orderId: this.orderId
    }
    queryDisclosureOrderInfo(params).then(res => {
      const { firstPic, title, sellerName, payTime, price } = res || {};
      this.firstPic = firstPic;
      this.title = title;
      this.sellerName = sellerName;
      this.payTime = payTime;
      this.price = price;
    }).catch(() => {
      setTimeout(() => {
        native.close()
      }, 1000)
    })
  }
}
</script>

<style scoped lang="less">
  @import 'index.less';
</style>
